var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionAct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.3346C14.6024 18.3346 18.3333 14.6037 18.3333 10.0013C18.3333 5.39893 14.6024 1.66797 10 1.66797C5.39763 1.66797 1.66667 5.39893 1.66667 10.0013C1.66667 14.6037 5.39763 18.3346 10 18.3346Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2684 6.88961C12.6755 6.7539 12.8791 6.68604 13.0145 6.73432C13.1323 6.77632 13.225 6.86903 13.267 6.98683C13.3153 7.1222 13.2474 7.32576 13.1117 7.73288L11.8721 11.4517C11.8334 11.5677 11.8141 11.6257 11.7812 11.6738C11.752 11.7165 11.7152 11.7533 11.6725 11.7825C11.6244 11.8154 11.5664 11.8347 11.4504 11.8734L7.73158 13.113C7.32446 13.2487 7.12089 13.3166 6.98553 13.2683C6.86772 13.2263 6.77502 13.1336 6.73301 13.0158C6.68474 12.8804 6.7526 12.6768 6.8883 12.2697L8.12792 8.55086C8.16657 8.43491 8.1859 8.37694 8.21883 8.32879C8.248 8.28615 8.28485 8.2493 8.32749 8.22014C8.37564 8.1872 8.43361 8.16788 8.54956 8.12923L12.2684 6.88961Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionAct);
export default __webpack_public_path__ + "static/media/action-act.cf18e6157df2c77a32c26fe8dfd849a7.svg";
export { ForwardRef as ReactComponent };